module.exports = __webpack_public_path__ + "media/images/presta_busc/psicologo-00fdbe171fb6ccd65a386914de80e07f.svg";